module.exports = __webpack_public_path__ + "static/media/citoesqueleto v2.3e654819.glb";